import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Form }  from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap';
import { useGetPublicplanQuery } from '../../slices/teachers/planApiSlice';
import {  useSubscribeinstripeMutation, useCancelstripesubscriptionMutation, useGetProfileQuery } from '../../slices/students/studentsApiSlice';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import { toast } from 'react-toastify';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import PublicPlan from '../../components/PublicPlan';

const StudentCancelSubscription = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { studentInfo } = useSelector((state) => state.authStudent);
    const [loading, setLoading] = useState(false);
    const [stripeid, setStripeid] = useState();
    const [questionsLeft, setQuestionsLeft] = useState(0);
    const [lastdate, setLastdate] = useState();

    const [cancelSubscription, { isLoading: loading2, error: error3 }] = useCancelstripesubscriptionMutation();
    const { data: plansData, error: plansError, isLoading: plansIsLoading } = useGetPublicplanQuery(id);
    const  { data, error2, isLoading2   } =  useGetProfileQuery();

    useEffect(() => {
      if(!studentInfo) {
          navigate('/studentlogin')
      }   
  }, [navigate, studentInfo])

    useEffect(() => {
        if (data && plansData) {
            data?.subscription.map((pla) => {
                if (pla.subject == plansData?.plan.subject && pla.plan == id && pla.renewal == true) {
                    setStripeid(pla.stripe_subscription_id);
                    setQuestionsLeft(pla.questionsLeft);
                    setLastdate(new Date(pla.endDate * 1000).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}))  

                    console.log(pla)
                }
            });
        }
    }, [data, plansData, id]);
              
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
      setLoading(true);
      const res = await cancelSubscription({ stripeid }).unwrap();
        dispatch(setStudentCredentials({ ...res.updatedStudent }));
        setLoading(false);        
        navigate("/studentasknew");
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader /><br />
            <div className="container-fluid mt--5 loginResponsive"><br />  
              <div className="container mt--10 pb-5 containerP subsc23">
                <div className="row bg-gradient-defaultt titleContainerP">
                  <h3 className=" tittleColor4 ">
                    <span className='tittleColor CancelT' style={{ textTransform: 'capitalize' }}>Cancel {plansData?.plan.subjectName} plan</span>
                  </h3><br />
                  <span className='tittleColor4 cancelT2'>
                    You have  {questionsLeft}  questions left  <br />
                  </span>
                  <span className='tittleColor4 cancelT2'>
                       Ask your remaining questions until {lastdate}
                  </span>
                    {plansIsLoading ? ( 
                                <Loader />
                            ) : plansError ? (
                                <Message variant='danger'>
                                    {plansError?.data?.message || plansError.error}
                                </Message>
                            ) : (
                              <div className=" offset-lg-3 col-lg-5 text-center"><br />
                                    <div className={`card card-pricing bg-gradient-primary shadow-lg rounded border-0 text-center mb-4` }>
                                        <div className="card-header bg-transparent">
                                            <h4 className="text-uppercase ls-1 text-white py-3 mb-0">Learning Plan</h4>
                                        </div>
                                        <div className="card-body px-lg-5">
                                            <div className="display-4 text-white">
                                              <span className='priceP3'>${plansData?.plan.price}</span>
                                              </div>
                                            <span className="text-white">monthly</span>
                                            <ul className="list-unstyled my-4">
                                                <li>
                                                    <div className="d-flex align-items-center publicPItem3">
                                                    <div>
                                                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                                                        <i className="fas fa-check"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className="pl-1 text-white">You can ask up to {plansData?.plan.totalQuestions} <br />
                                                          monthly questions </span>
                                                    </div>
                                                    </div>
                                                </li><br />
                                                <li>
                                                    <div className="d-flex align-items-center publicPItem3">
                                                    <div>
                                                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                                                        <i className="fas fa-check"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className="pl-2 text-white">Each Question can <br /> &nbsp; &nbsp; last up to 5 minutes</span>
                                                    </div>
                                                    </div>
                                                </li><br />
                                                <li>
                                                    <div className="d-flex align-items-center publicPItem3">
                                                    <div>
                                                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                                                        <i className="fas fa-check"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className="pl-2 text-white">
                                                        Record your screen or <br />
                                                        &nbsp;   camera to ask  questions
                                                          </span>
                                                    </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className=" align-items-center">                                                  
                                                        <div><br />
                                                        {!loading ? (
                                                        <Form >                                                        
                                                            <Button 
                                                              type="submit" 
                                                              className="btn btn-block btn-info bg-gradient-info" 
                                                              onClick={handleSubmit}>
                                                                Cancel Subscribtion
                                                              </Button>                                                                                                                                                                               
                                                        </Form>
                                                        ) : (   
                                                            <Loader />
                                                        )}

                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="card-footer bg-transparent card-footer2">
                                        </div>
                                    </div>    
                              </div>
                            )} 
                </div>
              </div>
            </div>
        </div>
      
    </div>
  )
}

export default StudentCancelSubscription
